"use strict";

angular.module('app.models.bundle', []).//
    factory('__Bundle', function (restmod, __Datapoint, __DatapointValue) {
        'ngInject';
        
        var model = restmod.model('/Bundle').mix('BaseModel').mix({
                $config: {
                    primaryKey: 'DatapointBundleId',
                    $pk: 'DatapointBundleId'
                },
                MenuEntries: {'hasMany': '__MenuEntry'},
                Datapoints: {hasMany: '__Datapoint', instanceOf: '__Bundle', ignore: true},
                DatapointValue: {hasOne: '__DatapointValue', ignore: true},

            setBundleVars: function () {


                      var  bundleOptions = {
                            scaleValues:[],
                            offsetValues : [],
                            alarmFlagDatapoints: [],
                            HWProviderSettingsDatapoints : [],
                            manualValues : [],
                            configValues : [],
                            manualModeDatapointValue : null,
                            hasOffsetValue : false,
                            hasActiveManualValue : false,
                            hasManualValue : false,
                            manualV : false,
                            hasActiveOffsetValue : false,
                            hasActualOrSetPointValue : false

                        };

                    for (var i = 0; i < this.Datapoints.length; i++) {


                        var category = this.Datapoints[i].DatapointConfig.Category;
                        switch(category)
                        {
                            case 0:
                            case 1:
                                bundleOptions.hasActualOrSetPointValue = true;
                                break;
                            case 2:
                            case 3:
                                bundleOptions.hasManualValue = true;
                                bundleOptions.manualValues.push( this.Datapoints[i] );
                                bundleOptions.configValues.push( this.Datapoints[i] );
                                if (category == 3 && ( this.Datapoints[i].DatapointValue.Value == 1  )) {
                                    //|| this.Datapoints[i].DatapointValue.Value == 2
                                    bundleOptions.hasActiveManualValue = true;
                                }
                                if (category == 3) {
                                    bundleOptions.manualModeDatapointValue = this.Datapoints[i];
                                }
                                break;
                            case 9:
                                bundleOptions.hasOffsetValue = true;
                                if(this.Datapoints[i].DatapointValue.Value != 0){bundleOptions.hasActiveOffsetValue = true;}
                                bundleOptions.configValues.push( this.Datapoints[i] );
                                bundleOptions.offsetValues.push( this.Datapoints[i] );
                                break;
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                                bundleOptions.hasAlarmFlagDatapoint = true;
                                bundleOptions.configValues.push( this.Datapoints[i] );
                                bundleOptions.configValues.push( this.Datapoints[i] );
                                bundleOptions.alarmFlagDatapoints.push( this.Datapoints[i] );
                                break;
                            case 10:
                                // HW ProviderSettings
                                bundleOptions.hasHWProviderSettings = true;
                                bundleOptions.configValues.push( this.Datapoints[i] );
                                bundleOptions.HWProviderSettingsDatapoints.push( this.Datapoints[i] );
                                break;
                            case 11:
                                bundleOptions.hasScaleValue = true;
                                bundleOptions.configValues.push( this.Datapoints[i] );

                                bundleOptions.scaleValues.push( this.Datapoints[i] );
                                break;
                        }


                    }

                    /*this.$UI.hasManualValue = hasManualValue;
                    this.$UI.hasOffsetValue = hasOffsetValue;
                    this.$UI.manualModeDatapointValue = manualModeDatapointValue;
                    this.$UI.hasActiveManualValue = hasActiveManualValue;*/
                    delete this.$UI;
                    this.$UI = angular.copy(bundleOptions);
                },


                $hooks: {
                    'build' : function(){


                            for (var j = 0; j < this.Datapoints.length; j++) {
                               this.Datapoints[j].$dispatch('build');
                            }

                    },
                    'refresh-bundle-vars' : function(){
                        this.setBundleVars();
                    },
                    'refresh-values': function (promise) {
                        console.debug(promise);
                        var dp = [];
                        var dps = {};

                        if(this.length == 0 ){ return };
                        for (var i = 0; i < this.length; i++) {

                            for (var j = 0; j < this[i].Datapoints.length; j++) {
                                var p = this[i].Datapoints[j];
                                var v = this[i].Datapoints[j].DatapointValue;
                                dps['k' + v.DatapointConfigId + '-d-' + v.DeviceId] = p;
                                dp.push(__DatapointValue.$buildRaw(v));
                            }
                        }
                        dp = __DatapointValue.$collection(dp).$refresh().$then(function () {
                            for (var i = 0; i < dp.length; i++) {
                                const currentDp = dp[i];
                                let point = dps['k' + currentDp.DatapointConfigId + '-d-' + currentDp.DeviceId];
                                point.DatapointValue.Value = currentDp.Value;
                                point.DatapointValue.Flags = currentDp.Flags;
                                point.setValue(currentDp.Value);

                                //dps['k' + currentDp.DatapointConfigId + '-d-' + currentDp.DeviceId].setReadValue();
                                point.setReadFlags();

                                if (point.DatapointConfig.$UI.Type === 'Date') {
                                    var momentTime = moment(point.readValue, 'YYYY-MM-DDTHH:mm:ss');
                                    point.readValue = momentTime.format('L') + ' ' + momentTime.format('LTS');
                                }
                                
                            }

                            this.$dispatch('refresh-bundle-vars');
                            if(promise) promise.resolve();
                        });



                    },
                    'after-feed': function (data) {
                        this.$UI = {};
                        this.setBundleVars();
                    }
                },
                $exdend: {
                    $buildRaw: function (data) {

                        this.Datapoints = __Datapoint.$buildRaw(this.Datapoints);
                        this.DatapointValue = __DatapointValue.$buildRaw(this.DatapointValue);

                        return this.$super();

                    },

                    Scope: {
                        $buildRaw: function (data) {
                            return this.$super();

                        }
                        ,
                        refreshDatapointValues: function (_params) {
                        }

                        ,
                        $save: function (data) {
                            return false;
                        }
                    }
                }
            })
            ;
        return model;

    });
